module.exports = __webpack_public_path__ + "static/media/KH.f15882bd.svg";